import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getSetting } from "./services/api/settingApi";
import ScrollToTop from "./Component/ScrollToTop";

import Header from "./Component/Header/Header";
import Footer from "./Component/Footer";
import Dashboard from "./Component/Dashboard";
import Product from "./Component/Product";
import OurProducts from "./Component/OurProduct";
import ProductInfoSection from "./Component/ProductInfoSection";

import RealStories from "./Component/RealStories";
import StayInTouch from "./Component/StayInTouch";
import ViralSection from "./Component/ViralSection";
import OriginalBabyWipes from "./Component/ProductDetails";
import AdviceCare from "./Component/AdviceCare";
import AdviceCareDetails from "./Component/AdviceCareDetails";
import ContactUs from "./Component/ContactUs";
import CookiePolicy from "./Component/CookiePolicy";
import TermsConditions from "./Component/TermsConditions";
import PrivacyPolicy from "./Component/PrivacyPolicy";
// import NewsMedia from "./Component/NewsAndMedia/NewsMedia";
// import Celebrating2025 from "./Component/NewsAndMedia/Celebrating2025";
// import GenderPayGap2024 from "./Component/NewsAndMedia/GenderPayGap2024";
// import GenderPayGap2023 from "./Component/NewsAndMedia/GenderPayGap2023";
// import GenderPayGap2022 from "./Component/NewsAndMedia/GenderPayGap2022";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

function App() {
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSetting();

        if (data?.favicon) {
          const link =
            document.querySelector("link[rel~='icon']") ||
            document.createElement("link");

          link.rel = "icon";
          link.href = data.favicon;

          document.head.appendChild(link);
        }

      } catch (error) {
        console.log("Error setting favicon");
      }
    };

    fetchSettings();
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />   {/* ✅ ADD HERE */}

        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Dashboard />
              <OurProducts />
              <ProductInfoSection />
              <RealStories />
              <ViralSection />
              <StayInTouch />
            </>
          } />
          <Route path="/product" element={<Product />} />
          <Route
            path="/advice-care"
            element={<AdviceCare />}
          />
          <Route path="/adviceCareDetails/:id" element={<AdviceCareDetails />} />

          <Route
            path="/products/original-baby-wipes"
            element={<OriginalBabyWipes />}
          />
          {/* <Route path="/newsMedia" element={<NewsMedia />} />
          <Route path="/news/celebrating-2025" element={<Celebrating2025 />} />
          <Route path="/news/GenderPayGap2024" element={<GenderPayGap2024 />} />
          <Route path="/news/GenderPayGap2023" element={<GenderPayGap2023 />} />
          <Route path="/news/GenderPayGap2022" element={<GenderPayGap2022 />} /> */}
          <Route path="/stayInTouch" element={<StayInTouch />} />
          <Route
            path="/contactus"
            element={<ContactUs />}
          />
          <Route
            path="/cookie-policy"
            element={<CookiePolicy />}
          />
          <Route
            path="/termsCondition"
            element={<TermsConditions />}
          />
             <Route
            path="/privacypolicy"
            element={<PrivacyPolicy />}
          />
        </Routes>

        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
